import { AXIS_HIGH_UNBOUNDED_NUMBER, AXIS_LOW_UNBOUNDED_NUMBER } from './constants';
import { MatrixDataType } from './types';
import type { MatrixModel } from 'flow/store/engine/types';

export const formatValueIfUnbounded = (value: number | string) => {
  if (typeof value === 'number') {
    if (
      value === AXIS_HIGH_UNBOUNDED_NUMBER
      || value === AXIS_LOW_UNBOUNDED_NUMBER
    ) {
      return 'unbounded';
    }
  }
  return value;
};

export const formatEmptyMatrixValuesByType = (
  matrix: MatrixModel['matrix'],
  matrixDataType: MatrixModel['matrixDataType'],
): MatrixModel['matrix'] => {
  if (matrixDataType === MatrixDataType.NUMBER) {
    return matrix.map(row => row.map(value => (typeof value !== 'number' ? null : value)));
  }

  return matrix.map(row => row.map(value => value ?? ''));
};
